import axios from "axios";
import { create } from "zustand";

const initialState = {
  loading: false,
  success: false,
  error: false,
  errorData: null,
  products: null,
  formatted_string: null,
};

export const useProductData = create((set, get) => ({
  ...initialState,
  get: async ({ postId, isMobile, affParam }) => {
    set({ ...initialState, loading: true });
    try {
      const res = await axios.post("/wp-json/core/products/v1/product_pack", {
        postId,
        isMobile,
        affParam,
      });
      set({
        ...initialState,
        success: true,
        products: res?.data?.products?.products,
        ...res?.data.products,
        formatted_string: res?.data.formatted_string,
        country_code: res?.data?.country?.toUpperCase(),
      });
    } catch (err) {
      set({ ...initialState, error: true, errorData: err.message });
    }
  },
  changeProductsShippingPrice: (shippingPrice) => {
    return set((state) => ({
      ...state,
      products:
        state?.products?.length > 0 &&
        state?.products?.map((product) => ({
          ...product,
          shipping_price: shippingPrice,
        })),
    }));
  },
}));
